<template>
  <div>
    <ul class="content" v-loading="loading">
      <router-link :to="{ path: `/navigator/bbs/cooperationDetails/${item.serviceId}` }" v-for="item in cooperationList" :key="item.serviceId">
        <List :msg="item"></List>
      </router-link>
    </ul>
     <div class='pages main-pagination' v-if="pageTotal > 16">
        <el-pagination :page-size="16" layout="prev, pager, next, jumper" background @current-change="handleCurrentChange" :total="pageTotal"></el-pagination>
    </div>

    <Nothing v-if="!cooperationList.length && !loading"></Nothing>

  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import List from '../components/List';

export default {
  data() {
    return {
      cooperationList: [],
      pageIndex: 1,
      pageTotal: 0,
      loading: true,
    }
  },
  components: {
    List,
  },
  methods: {
    getList() {  // 获取求购服务列表
      this.loading = true;
      setTimeout(() => {
        this.loading = false;
      }, 5000);
      this.$http.post(`${this.URL_PREFIX}/app/get/ask/service/list`, {
        parkId: this.currentParkId,
        currPage: this.pageIndex,
        pageRows: 16,
      }).then((response) => {
        const res = response.data;
        this.loading = false;
        if (res.resCode === '10000') {
          this.cooperationList = res.resData.pageList ? res.resData.pageList : [];
          this.pageTotal = res.resData.pageInfo ? res.resData.pageInfo.total : 0;
        }
      });
    },
    handleCurrentChange(val) {  // 改变页数
      this.pageIndex = val;
      this.getList();
    },
  },
  computed: {
    ...mapGetters(['currentParkId']),
  },
  mounted() {
    this.getList();
  },
}
</script>

<style lang="scss" scoped>
.content {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.pages{
  margin-top: 60px;
  margin-bottom: 60px;
  text-align: center;
}
</style>




// WEBPACK FOOTER //
// src/pages/navigator/bbs/cooperation/Cooperation.vue